import React, {useCallback, useState} from 'react';
import Select from 'react-select';
import FileUploader from '../FileUploader';
import * as shortid from 'shortid';
import {FormGroup} from 'reactstrap';
import {all, equals, is, isNil, values} from 'ramda';

const FBSelect = (props) => {
    const {onChange, onHoverTab, ...rest} = props;

    const formatOptionLabel = ({value, label}) => {
        const handleHoverTab = (e) => {
            if (!!onHoverTab) {
                return onHoverTab(label, value)
            } else {
                return () => {}
            }
        }
        return (
            <div style={{display: "flex"}} onMouseOver={handleHoverTab}>
                <div>{label}</div>
            </div>
        );
    };

    const handleChange = useCallback(selectedOptions => {
        if (is(Array, selectedOptions) && onChange) {
            onChange(rest.name, selectedOptions);
        } else if (onChange) {
            onChange(rest.name, selectedOptions);
        }
    });

    return (
        <Select {...rest} onChange={handleChange} formatOptionLabel={formatOptionLabel}/>
    )
};

const FBFileUpload = (props) => {
    const {onFileUpload, ...rest} = props;
    const handleUpload = useCallback(value => onFileUpload(rest.name, value));

    return (
        <FileUploader onFileUpload={handleUpload} {...rest}/>
    );
}

const FBCheckboxGroup = (props) => {
    const {name, hidden, options, validations} = props;
    const required = !isNil(validations.required) || false;
    const initialState = {};
    options.forEach(option => initialState[option.label] = option.value);

    const [checkboxesState, setCheckboxesState] = useState(initialState);

    const handleChange = useCallback(event => {
        if (event.target.name) {
            const newState = {...checkboxesState};
            newState[event.target.name] = !newState[event.target.name];
            const invalid = all(equals(false))(values(newState)) && required;

            if (!invalid) {
                props.onChange(name, newState);
            } else {
                props.onError(name, 'required', validations.required || 'At least one field must be selected')
            }

            setCheckboxesState(newState);
        }
    });

    const checkboxes = options.map(option => (
        <div className="custom-checkbox custom-control" key={shortid.generate()}>
            <input type="checkbox" id={`cb-${option.label}`}
                   name={option.label}
                   disabled={option.disabled || false}
                   defaultChecked={checkboxesState[option.label]}
                   className="custom-control-input"
                   hidden={hidden}
                   onChange={handleChange}
            />
            <label className="custom-control-label" htmlFor={`cb-${option.label}`}>
                {option.label}
            </label>
        </div>
    ));

    return (
        <FormGroup>
            <input name={name} hidden/>
            {checkboxes}
        </FormGroup>
    );
}

export {FBSelect, FBCheckboxGroup, FBFileUpload};
